import React, { forwardRef } from "react";
import PropTypes from "prop-types";

import { Tile } from "../Tile";

import TariffTileName from "./TariffTileName";
import TariffTileHeroFeature from "./TariffTileHeroFeature";
import TariffTilePrice from "./TariffTilePrice";
import TariffTilePriceText from "./TariffTilePriceText";
import TariffTileList from "./TariffTileList";
import TariffTileListItem from "./TariffTileListItem";
import TariffTileListItemDescription from "./TariffTileListItemDescription";
import TariffTileLinks from "./TariffTileLinks";
import TariffTileLink from "./TariffTileLink";
import TariffTileButton from "./TariffTileButton";
import Bonus from "./Bonuses/Bonus";
import BonusPrice from "./Bonuses/BonusPrice";
import BonusText from "./Bonuses/BonusText";
import BonusAsterisk from "./Bonuses/BonusAsterisk";

export const TariffTile = forwardRef((props, ref) => {
  const { children, ...restProps } = props;

  return (
    <Tile ref={ref} variant="shadow" {...restProps}>
      <Tile.Content>{children}</Tile.Content>
    </Tile>
  );
});

TariffTile.displayName = "TariffTile";

TariffTile.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

TariffTile.Name = TariffTileName;
TariffTile.Hero = TariffTileHeroFeature;
TariffTile.Price = TariffTilePrice;
TariffTile.List = TariffTileList;
TariffTile.ListItem = TariffTileListItem;
TariffTile.ListItemDescription = TariffTileListItemDescription;
TariffTile.PriceText = TariffTilePriceText;
TariffTile.TariffTileList = TariffTileList;
TariffTile.Links = TariffTileLinks;
TariffTile.Link = TariffTileLink;
TariffTile.Button = TariffTileButton;
TariffTile.Bonus = Bonus;
TariffTile.BonusPrice = BonusPrice;
TariffTile.BonusText = BonusText;
TariffTile.BonusAsterisk = BonusAsterisk;

export default TariffTile;
